/* eslint-disable react/require-default-props */
import { Button, Typography } from '@mui/material';
import { useState } from 'react';

import { MultilineTextField } from '../../../../../../components/CustomInput';
import { ButtonBox } from '../../../../../../components/UI/Box';
import { IconAttachFileMS } from '../../../../../../constants/icons';
import {
  DialogContainer,
  OutlinedButton,
  StyledDialog,
  TextTypography,
} from '../styles';

interface RejectDialogProps {
  docId?: number;
  name: string;
  document: string;
  docLoading: boolean;
  disabled: boolean;
  handleReject: (reason: string, docId?: number) => Promise<void>;
  disapprove?: boolean;
}

export function RejectDialog({
  docId,
  name,
  document,
  docLoading,
  disabled,
  handleReject,
  disapprove = false,
}: RejectDialogProps): JSX.Element {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState('');

  const handleOpen = (): void => setOpen(true);
  const handleClose = (): void => setOpen(false);

  const handleConfirm = (): void => {
    handleReject(reason, docId).then(() => handleClose());
  };

  return (
    <>
      <OutlinedButton onClick={handleOpen} disabled={disabled}>
        {disapprove ? 'desaprovar' : 'rejeitar'}
      </OutlinedButton>
      <StyledDialog open={open} onClose={handleClose}>
        <DialogContainer>
          <Typography>
            O documento <span style={{ fontWeight: '600' }}>{name}</span> será
            rejeitado.
          </Typography>
          <TextTypography>
            {IconAttachFileMS}
            {document}
          </TextTypography>
          <MultilineTextField
            id="findings"
            label=""
            placeholder="Explique o motivo da rejeição"
            value={reason}
            setValue={setReason}
            maxLength={500}
          />
          <ButtonBox gap={2} my={2.5}>
            <Button
              sx={{ width: '200px', height: '48px' }}
              disabled={docLoading}
              onClick={handleConfirm}
            >
              rejeitar
            </Button>
            <OutlinedButton
              sx={{ maxWidth: '200px', width: '200px', height: '48px' }}
              disabled={docLoading}
              onClick={handleClose}
            >
              cancelar
            </OutlinedButton>
          </ButtonBox>
        </DialogContainer>
      </StyledDialog>
    </>
  );
}
